import React from 'react'

import styled from 'styled-components'
const BREAKPOINTS = {
  desktop: 1680,
  laptop: 1072,
  tablet: 711,
  mobile: 0,
}
export const Centered = styled.div`
  display: grid;

  @media only screen and (min-width: ${BREAKPOINTS.mobile}px) {
    grid-template-columns: 2rem auto 2rem;
  }

  @media only screen and (min-width: ${BREAKPOINTS.tablet}px) {
    grid-template-columns: auto 664px auto;
  }

  @media only screen and (min-width: ${BREAKPOINTS.laptop}px) {
    grid-template-columns: auto 1016px auto;
  }

  @media only screen and (min-width: ${BREAKPOINTS.desktop}px) {
    grid-template-columns: auto 1365px auto;
  }
`

export const _ContentGrid = styled.div<{ disableInnerGrid: boolean }>`
  display: ${(props) => (props.disableInnerGrid ? 'block' : 'grid')};
  grid-column: 2;
  grid-gap: 0;
  position: relative;
  @media only screen and (min-width: ${BREAKPOINTS.mobile}px) {
    column-gap: 20px;
    grid-template-columns: repeat(2, 1fr);
  }
  @media only screen and (min-width: ${BREAKPOINTS.tablet}px) {
    column-gap: 24px;
    grid-template-columns: repeat(8, 1fr);
  }
  @media only screen and (min-width: ${BREAKPOINTS.laptop}px) {
    grid-template-columns: repeat(12, 1fr);
    column-gap: 28px;
  }
  @media only screen and (min-width: ${BREAKPOINTS.desktop}px) {
    grid-template-columns: repeat(12, 1fr);
    column-gap: 28px;
  }
`
interface IContentGrid {
  disableInnerGrid?: boolean
  children: string | JSX.Element | JSX.Element[]
}
export const ContentGrid: React.FC<IContentGrid> = ({
  children,
  disableInnerGrid = false,
}) => {
  return (
    <Centered>
      <_ContentGrid disableInnerGrid={disableInnerGrid}>
        {children && children}
      </_ContentGrid>
    </Centered>
  )
}
